import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import AhPwdlessCommonsUtility from "utilities/login/ah-pwdless-common-utility/1.0.0/js/ah-pwdless-common-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import ahInputValidationUtility from "utilities/login/ah-input-validation-utility/1.0.0/js/ah-input-validation-utility";
import ahModalUtility from "utilities/login/ah-modal-utility/2.0.0/js/ah-modal-utility";
import ahPubsubUtility from "utilities/login/ah-pubsub-utility/2.0.0/js/ah-pubsub-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import DIController from "modules/login/ah-di-module/2.0.1/js/ah-di-controller";
import DIView from "modules/login/ah-di-module/2.0.1/js/ah-di-view";
import DIModel from "modules/login/ah-di-module/2.0.1/js/ah-di-model";
import spartaTemplates from "modules/login/ah-di-module/2.0.1/js/templates";
import "css!modules/login/ah-di-module/2.0.1/css/ah-di-module.scss.css";
















export default class AhDiModule extends Module {




  constructor(options) {
    Object.assign(options, {
        target: options.target,
        debug: true,
        events: {
            namespace: 'ah-di-module',
        },
    });
    super(options);

    this.ERRORS = options.ERRORS;

    this.clientParams = options.clientParams;
    this.$moduleContext = $(this.settings.target);
    this.$ = $;

    this.Handlebars = Handlebars;
    this._ = _;
    this.ahCawCommons = ahCawCommons;


    this.cawEventsMaster = cawEventsMasterUtility;

     this.basePath = this.ahCawCommons.getBasePath(this.spaParams);
     this.apiEndPoints = {};
     this.endpoints = options.apiEndPoints;
     this.apiEndPoints = ahCawCommons.getEndPoints(options.apiEndPoints, this.basePath);
	 this.ahPwdlessCommons = new AhPwdlessCommonsUtility();

  }






  init(options = {}) {
    console.log('Module "ah-di-module" called with options:', options);
    this.setupMVC();

    $(this.view.settings.target).spartaInputs();
  }
  setupMVC() {
      Object.assign(this.view, new DIView(this));
      Object.assign(this.model, new DIModel(this));
      Object.assign(this.controller, new DIController(this));

      this.view.initialize();
      this.model.initialize();
      this.controller.initialize();

      this._debug(this.view);
      this._debug(this.controller);
      this._debug(this.model);
  }

  buildView() {
      Object.assign(this.view, new DIView(this));
      this._debug(this.view);
  }

  buildController() {
      Object.assign(this.controller, new DIController(this));
      this._debug(this.controller);
  }

  buildModel() {
      Object.assign(this.model, new DIModel(this));
      this._debug(this.model);
  }
}
